// Source: src/components/CtaSection.tsx. Values include intentional inline spacing.
const en = {
  "s1": "Contact Us",
  "s2": "We know that our clients have unique needs. Get in touch, and we will get back to you soon.",
  "s3": "Email Us",
  "s4": "Subscribe to Our Newsletter",
  "s5": "Stay updated with the latest news, features, and insights from GizmoData.",
  "s6": "Subscribe on Substack",
  "s7": "Send us a message",
  "s8": "Tell us what you’re running and what you’re trying to fix. Your message goes straight to the founder — we reply within one business day.",
  "s9": "Contact Us"
};
const pt: typeof en = {
  "s1": "Entre em contato",
  "s2": "Sabemos que nossos clientes têm necessidades únicas. Entre em contato e retornaremos em breve.",
  "s3": "Envie um e-mail",
  "s4": "Assine nossa newsletter",
  "s5": "Acompanhe as novidades, os recursos e os insights da GizmoData.",
  "s6": "Assine no Substack",
  "s7": "Envie uma mensagem",
  "s8": "Conte o que você usa e o que está tentando resolver. Sua mensagem vai direto para o fundador — respondemos em até um dia útil.",
  "s9": "Entre em contato"
};
export default { en, 'pt-BR': pt };
